const handleSyncAdvancedOptionClick = (e: Event): void => {
  const elem = e.target as HTMLElement

  elem.classList.toggle('icon-chevron-down')
  elem.classList.toggle('icon-chevron-up')

  const advancedOptionSection = elem.closest(
    '.advanced-option-section'
  ) as HTMLElement

  const children = advancedOptionSection.children
  children[children.length - 1].classList.toggle('sf-hidden')
}

export default (): void => {
  window.onDomLoad(function ($dom) {
    $dom.off('click', '[data-behaviour~="sync-advanced-option"]')

    $dom.on(
      'click',
      '[data-behaviour~="sync-advanced-option"]',
      handleSyncAdvancedOptionClick
    )
  })
}
